import UI from "./elements.module";

class EventsModule {

	// Get DOM elements
	private ui = new UI()

	// Private Methods
	private get currentPage() {
		return window.location.pathname;
	}

	private getEventValue(target: string) {
		const getEventValue: HTMLInputElement | null = document.querySelector("#eventSelect")
		return getEventValue && (getEventValue.value = target)
	}

	// Public Methods
	handleAttendanceEventSelection() {
		const eventButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll("[data-evt-btn]")


		eventButtons.forEach((eventButton) => {

			eventButton.addEventListener('click', (e: Event) => {
				const target = e.target as HTMLButtonElement;
				const parent = target.closest("[data-evt-btn]")

				if (!parent) return

				const activeElement = parent.querySelector(".active")

				if (activeElement && activeElement !== target) {
					activeElement.classList.remove("active")
				}

				target.classList.toggle("active")
				this.getEventValue(target.value.toLowerCase())

			})
		})

	}

}

export default EventsModule
